export const JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY =
	'jsm-repackaging-announcement-dismiss-state' as const;

export const DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE = {
	shouldShow: true,
} as const;
